/**
 * DevExtreme (esm/__internal/grids/grid_core/row_dragging/const.js)
 * Version: 23.2.10
 * Build date: Mon Oct 28 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
export var ATTRIBUTES = {
    dragCell: "dx-drag-cell"
};
export var CLASSES = {
    cellFocusDisabled: "dx-cell-focus-disabled",
    handleIcon: "drag-icon",
    commandDrag: "dx-command-drag",
    sortableWithoutHandle: "dx-sortable-without-handle",
    rowsView: "rowsview",
    dragView: "dragview"
};
